import { cn } from '@/lib/utils';
import { CornerDownRight, Search } from 'lucide-react';

// 建议下拉组件
interface SuggestionDropdownProps {
  suggestions: string[];
  onSelect: (suggestion: string) => void;
  visible: boolean;
  position?: 'above' | 'below';
  isResearch?: boolean;
}

const SuggestionDropdown: React.FC<SuggestionDropdownProps> = ({
  suggestions,
  onSelect,
  visible,
  position = 'below',
  isResearch,
}) => {
  if (!visible || suggestions.length === 0) return null;

  const positionClasses =
    position === 'above'
      ? 'absolute bottom-[calc(100%+12px)] left-0 right-0'
      : 'absolute top-full left-0 right-0';

  return (
    <div className={`${positionClasses} z-50`}>
      {/* 顶部边框线 */}
      {position === 'below' && <div className="mx-px border-t border-border-divider"></div>}

      {/* 带渐变边框的主容器 */}
      {/* <div
        className={cn('bg-[#171717] p-px', {
          'pt-0! rounded-b-2xl': position === 'below',
          'rounded-2xl': position === 'above',
        })}
      > */}
      <div className={`bg-[#171717] p-2 ${position === 'below' ? 'rounded-b-2xl' : 'rounded-2xl'}`}>
        {/* <div className="text-sm text-[#B7B9BC] leading-8 pl-3">Trending questions</div> */}
        <div className="flex flex-col gap-1">
          {suggestions.slice(0, 3).map((suggestion, index) => (
            <button
              key={index}
              type="button"
              onClick={() => onSelect(suggestion)}
              className="text-left px-3 py-2 text-[14px] text-text-primary hover:bg-bg-card-hover rounded-lg transition-colors duration-150 flex items-center gap-2"
            >
              {/* <Search size={16} className="text-text-secondary shrink-0" /> */}
              <CornerDownRight size={16} className="text-text-secondary shrink-0" />
              <span>{suggestion}</span>
            </button>
          ))}
        </div>
      </div>
      {/* </div> */}
    </div>
  );
};

export default SuggestionDropdown;
